"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsTrafficToJSON = exports.AnalyticsTrafficFromJSONTyped = exports.AnalyticsTrafficFromJSON = exports.instanceOfAnalyticsTraffic = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AnalyticsTraffic interface.
 */
function instanceOfAnalyticsTraffic(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAnalyticsTraffic = instanceOfAnalyticsTraffic;
function AnalyticsTrafficFromJSON(json) {
    return AnalyticsTrafficFromJSONTyped(json, false);
}
exports.AnalyticsTrafficFromJSON = AnalyticsTrafficFromJSON;
function AnalyticsTrafficFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'pageviews': !(0, runtime_1.exists)(json, 'pageviews') ? undefined : json['pageviews'],
    };
}
exports.AnalyticsTrafficFromJSONTyped = AnalyticsTrafficFromJSONTyped;
function AnalyticsTrafficToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'pageviews': value.pageviews,
    };
}
exports.AnalyticsTrafficToJSON = AnalyticsTrafficToJSON;
